var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view-container" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "tab" }, [
          _c(
            "span",
            {
              staticClass: "tabItem",
              class: { active: _vm.active === 0 },
              on: {
                click: function ($event) {
                  return _vm.handleTabClick(0)
                },
              },
            },
            [_vm._v("海运")]
          ),
          _c(
            "span",
            {
              staticClass: "tabItem",
              class: { active: _vm.active === 1 },
              on: {
                click: function ($event) {
                  return _vm.handleTabClick(1)
                },
              },
            },
            [_vm._v("空运")]
          ),
        ]),
        _c(
          "div",
          { staticClass: "optheader" },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "permission",
                    rawName: "v-permission",
                    value: "export",
                    expression: "'export'",
                  },
                ],
                staticClass: "btn flex_c_c",
                staticStyle: { "margin-right": "12px" },
                on: { click: _vm.handleExport },
              },
              [_c("i", { staticClass: "el-icon-download" }), _vm._v(" 导出 ")]
            ),
            _c(
              "BaseFilter",
              {
                attrs: { "is-active": _vm.isActive, width: 466 },
                on: {
                  sendFilter: _vm.handleSearchOk,
                  reset: _vm.handleSearchReset,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "filter" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "searchForm",
                        attrs: { model: _vm.searchData, "label-width": "70px" },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "客户" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "310px" },
                                attrs: {
                                  filterable: "",
                                  multiple: "",
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.searchData.companyId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchData, "companyId", $$v)
                                  },
                                  expression: "searchData.companyId",
                                },
                              },
                              _vm._l(_vm.companyOptions, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "搜索" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "320px" },
                              attrs: { placeholder: "提单号" },
                              model: {
                                value: _vm.searchData.search,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchData, "search", $$v)
                                },
                                expression: "searchData.search",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "data" },
        [
          _c(
            "el-tabs",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "el-tabs",
              attrs: { type: "border-card" },
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.status,
                callback: function ($$v) {
                  _vm.status = $$v
                },
                expression: "status",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: `所有(${_vm.form.all})`, name: "All" },
              }),
              _c("el-tab-pane", {
                attrs: { label: `未发送(${_vm.form.one})`, name: "NotSent" },
              }),
              _c("el-tab-pane", {
                attrs: { label: `发送中(${_vm.form.two})`, name: "Sending" },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: `已发送(${_vm.form.three})`,
                  name: "HasBeenSent",
                },
              }),
              _c(
                "div",
                { staticClass: "table" },
                [
                  _c("BaseTable", {
                    key: _vm.status,
                    attrs: {
                      height: _vm.height,
                      "table-data": { ..._vm.list, fileds: _vm.fileds },
                      "page-number": _vm.pager.PageIndex,
                      "page-size": _vm.pager.PageSize,
                    },
                    on: {
                      handlePageChange: _vm.handlePageChange,
                      dblclick: _vm.handleRowDoubleClick,
                      "selection-change": _vm.handleSelectionChange,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "opt",
                        fn: function (row) {
                          return [
                            _c(
                              "el-popover",
                              {
                                ref: `popover${row.scope.id}`,
                                attrs: {
                                  placement: "bottom-start",
                                  "popper-class": "pop-table-opt",
                                  width: "114",
                                  trigger: "click",
                                },
                              },
                              [
                                _c("div", { staticClass: "table-opt" }, [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "opt-item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleCommand(
                                                "firmcode",
                                                row.scope
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" Firmcode ")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    [
                                      row.scope.firmCode != undefined &&
                                      _vm.active === 0
                                        ? _c(
                                            "el-button",
                                            {
                                              staticClass: "opt-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleCommand(
                                                    "sendAnEmail",
                                                    row.scope
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" 发送AN ")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    [
                                      row.scope.firmCode != undefined
                                        ? _c(
                                            "el-button",
                                            {
                                              staticClass: "opt-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleCommand(
                                                    "sendDoEmail",
                                                    row.scope
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" 发送DO ")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("img", {
                                  attrs: {
                                    slot: "reference",
                                    src: require("@/assets/images/table/opt.png"),
                                  },
                                  slot: "reference",
                                }),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "fileNumber",
                        fn: function (row) {
                          return [
                            _c(
                              "i",
                              {
                                staticClass: "el-icon-folder-opened",
                                staticStyle: { color: "black" },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewFile(row.scope)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(row.scope.fileNumber))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            visible: _vm.dialogFormVisible,
            title: "AN/DO记录添加FirmCode",
            "destroy-on-close": true,
            "before-close": _vm.handleDialogClose,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "36%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading2,
                  expression: "loading2",
                },
              ],
              ref: "form1",
              attrs: { model: _vm.form1, rules: _vm.rules1 },
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "2px" },
                  attrs: { label: "清关行：", prop: "supplierClearenceId" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请输入选择清关行" },
                      model: {
                        value: _vm.form1.supplierClearenceId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form1, "supplierClearenceId", $$v)
                        },
                        expression: "form1.supplierClearenceId",
                      },
                    },
                    _vm._l(_vm.supplierOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: item.code + "-" + item.wbName,
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "2px" },
                  attrs: { label: "FirmCode", prop: "firmCode" },
                },
                [
                  _c(
                    "el-popover",
                    { attrs: { placement: "right-end", trigger: "hover" } },
                    [
                      _c("pre", [
                        _vm._v("输入关键词为1111即可筛选空白FirmCode"),
                      ]),
                      _c("el-button", {
                        staticStyle: {
                          color: "red",
                          display: "flex",
                          "margin-top": "5px",
                          "margin-bottom": "5px",
                        },
                        attrs: {
                          slot: "reference",
                          icon: "el-icon-chat-dot-round",
                          size: "mini",
                          circle: "",
                        },
                        slot: "reference",
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        remote: "",
                        "reserve-keyword": "",
                        placeholder: "请输入关键词(至少3个字符)",
                        "popper-class": "firmcode-select",
                        "remote-method": _vm.remoteMethod,
                        loading: _vm.loading1,
                      },
                      on: { focus: _vm.handleFocus },
                      model: {
                        value: _vm.form1.firmCodeId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form1, "firmCodeId", $$v)
                        },
                        expression: "form1.firmCodeId",
                      },
                    },
                    _vm._l(_vm.firmCodeOption, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.active === 0
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "2px" },
                      attrs: {
                        label: "FirmCode替换地址信息",
                        prop: "firmCodeInformation",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          placeholder: "公司名称 详细地址 城市地址 州地址 邮编",
                        },
                        model: {
                          value: _vm.form1.firmCodeInformation,
                          callback: function ($$v) {
                            _vm.$set(_vm.form1, "firmCodeInformation", $$v)
                          },
                          expression: "form1.firmCodeInformation",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "2px" },
                  attrs: { label: "FORDELIVERYTO", prop: "FORDELIVERYTO" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder:
                        "公司名 详细地址 城市地址 省份地址 国家地址 邮编",
                    },
                    model: {
                      value: _vm.form1.fordeLiveryTo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form1, "fordeLiveryTo", $$v)
                      },
                      expression: "form1.fordeLiveryTo",
                    },
                  }),
                ],
                1
              ),
              _vm.active != 0
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "2px" },
                      attrs: { label: "ENTRY", prop: "ENTRY" },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 1,
                          placeholder: "ENTRY",
                        },
                        model: {
                          value: _vm.form1.entry,
                          callback: function ($$v) {
                            _vm.$set(_vm.form1, "entry", $$v)
                          },
                          expression: "form1.entry",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.active != 0
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "2px" },
                      attrs: { label: "remark", prop: "remark" },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 2,
                          placeholder: "备注",
                        },
                        model: {
                          value: _vm.form1.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form1, "remark", $$v)
                          },
                          expression: "form1.remark",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              staticStyle: { display: "contents", "padding-top": "-10px" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleDialogClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading2 },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("确 认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            visible: _vm.dialogFormVisible1,
            title: _vm.title,
            "destroy-on-close": false,
            "before-close": _vm.ANAndDohandleDialogClose,
            width: "36%",
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible1 = $event
            },
            opened: _vm.selectAllRows,
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "form2",
              attrs: {
                model: _vm.form2,
                rules: _vm.rules2,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "清关行：", prop: "supplierClearenceId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请输入选择清关行",
                      },
                      on: { change: _vm.supplierCodeChange },
                      model: {
                        value: _vm.form2.supplierClearenceId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form2, "supplierClearenceId", $$v)
                        },
                        expression: "form2.supplierClearenceId",
                      },
                    },
                    _vm._l(_vm.supplierOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: item.code + "-" + item.wbName,
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Email To", prop: "receiver" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      autocomplete: "off",
                      autosize: { minRows: 1, maxRows: 4 },
                    },
                    model: {
                      value: _vm.form2.receiver,
                      callback: function ($$v) {
                        _vm.$set(_vm.form2, "receiver", $$v)
                      },
                      expression: "form2.receiver",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "CC：" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      autocomplete: "off",
                      placeholder: "请输入电子邮件地址",
                      autosize: { minRows: 1, maxRows: 4 },
                    },
                    on: { blur: _vm.validateEmailList },
                    model: {
                      value: _vm.form2.cc,
                      callback: function ($$v) {
                        _vm.$set(_vm.form2, "cc", $$v)
                      },
                      expression: "form2.cc",
                    },
                  }),
                ],
                1
              ),
              _vm.validationError
                ? _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v(_vm._s(_vm.validationError)),
                  ])
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "主题", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      "show-word-limit": "",
                      autosize: { minRows: 1, maxRows: 4 },
                    },
                    model: {
                      value: _vm.form2.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.form2, "title", $$v)
                      },
                      expression: "form2.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "正文", prop: "content" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      "show-word-limit": "",
                      autosize: { minRows: 2, maxRows: 4 },
                    },
                    model: {
                      value: _vm.form2.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.form2, "content", $$v)
                      },
                      expression: "form2.content",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "请勾选需要发送的文件",
                    "label-width": "240",
                  },
                },
                [
                  _c("Table", {
                    ref: "customTable",
                    attrs: {
                      tableData: _vm.tableData1,
                      height: 170,
                      pageFooter: false,
                    },
                    on: { selectionchange: _vm.selectionchange2 },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (row) {
                          return [
                            _c(
                              "el-button",
                              { attrs: { type: "text", size: "mini" } },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: { "font-size": "12px" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.download(row.scope)
                                      },
                                    },
                                  },
                                  [_vm._v("下载")]
                                ),
                              ]
                            ),
                            [".pdf", ".PDF", ".JPG", ".jpg"].includes(
                              row.scope.suffix
                            )
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { "font-size": "12px" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.preview(row.scope)
                                      },
                                    },
                                  },
                                  [_vm._v(" 预览 ")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              staticStyle: { display: "contents", "margin-top": "-30px" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.ANAndDohandleDialogClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.ANAndDOsubmitForm },
                },
                [_vm._v("发 送")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ClearenceFileDialog", {
        attrs: { rowData: _vm.rowData, dialogVisible: _vm.dialogVisible1 },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible1 = false
          },
        },
      }),
      _c("DetailDrawer", {
        attrs: {
          drawer: _vm.drawer1,
          billType: _vm.active,
          rowData: _vm.rowData,
        },
        on: {
          close: function ($event) {
            _vm.drawer1 = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }